"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = exports.size = exports.space = void 0;
/**
 * The available spacing.
 *
 * Here's the rough guideline.  Customize this for you usage.  It's ok to put exceptions
 * within the components themselves if they are truly exceptions.
 *
 * 0 = none    - nothing. only here to bust out of a zero-based array.
 * 1 = tiny    - elements contextually close to each other
 * 2 = smaller - for groups of closely related items or perhaps borders
 * 3 = small   - ?
 * 4 = medium  - ?
 * 5 = medium+ - ?
 * 6 = large   - between groups of content that aren't related?
 * 7 = huge    - ?
 * 8 = massive - an uncomfortable amount of whitespace
 */
exports.space = {
    none: 0,
    tiny: 4,
    smaller: 8,
    small: 12,
    medium: 16,
    large: 24,
    larger: 32,
    huge: 48,
    massive: 64
};
exports.size = {
    borderWidth: {
        none: 0,
        tiny: 1,
        small: 2,
        medium: 3,
        large: 4,
    },
    borderRadius: Object.assign({}, exports.space),
};
exports.spacing = Object.values(exports.space);
//# sourceMappingURL=spacing.js.map